import { TransactionError, mapCosmosCode } from './errors.js';
const DEFAULT_CONFIRM_TIMEOUT_MS = 30_000;
const DEFAULT_POLL_INTERVAL_MS = 2_000;
const SEQUENCE_MISMATCH_CODE = 13;
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
async function pollForConfirmation(deps, hash, pollIntervalMs, confirmTimeoutMs) {
    const deadline = Date.now() + confirmTimeoutMs;
    while (Date.now() < deadline) {
        try {
            const res = await deps.client.getApi(`/cosmos/tx/v1beta1/txs/${hash}`);
            const txResponse = res.tx_response;
            if (txResponse) {
                if (txResponse.code === 0) {
                    return hash;
                }
                throw mapCosmosCode(txResponse.code, txResponse.raw_log);
            }
        }
        catch (err) {
            // 404 / not-found while the tx propagates is expected — keep polling.
            if (err instanceof TransactionError) {
                throw err;
            }
        }
        await sleep(pollIntervalMs);
    }
    throw new TransactionError('CONFIRMATION_TIMEOUT', 'errors.tx.confirmationTimeout', { txHash: hash });
}
export async function broadcastAndConfirm(deps, txBytes, options = {}, refetchAndResign) {
    const pollIntervalMs = options.pollIntervalMs ?? DEFAULT_POLL_INTERVAL_MS;
    const confirmTimeoutMs = options.confirmTimeoutMs ?? DEFAULT_CONFIRM_TIMEOUT_MS;
    let bytes = txBytes;
    let result = await deps.broadcastTx(bytes);
    if (result.code === SEQUENCE_MISMATCH_CODE && refetchAndResign) {
        bytes = await refetchAndResign();
        result = await deps.broadcastTx(bytes);
    }
    if (result.code !== 0) {
        throw mapCosmosCode(result.code, result.rawLog);
    }
    return pollForConfirmation(deps, result.transactionHash, pollIntervalMs, confirmTimeoutMs);
}
//# sourceMappingURL=broadcast.js.map